import { startModuleAccessBootstrap } from './services/inflow/moduleAccessBootstrap';
import { LicenseInfo } from "@mui/x-license";

const reactAppMuiXLicenceKey = process.env.REACT_APP_MUI_X_LICENCE_KEY || "";
LicenseInfo.setLicenseKey(reactAppMuiXLicenceKey);

const isPublicBooking = /^\/inflow\/book\/[a-z0-9-]{3,80}\/?$/.test(window.location.pathname) || (process.env.NODE_ENV==='development' && /^\/inflow\/book-fixture\/[a-z0-9-]{3,80}\/?$/.test(window.location.pathname));
const isBookingSettingsPreview = process.env.NODE_ENV === 'development' && ['localhost','127.0.0.1'].includes(window.location.hostname) && window.location.pathname === '/inflow/bookings-preview';
startModuleAccessBootstrap();
// Fetch the selected tool's code alongside the application shell. Importing it
// does not mount it or run its data hooks; fresh access still gates rendering.
if (/^\/inflow\/dashboard\/?$/.test(window.location.pathname)
    && new URLSearchParams(window.location.search).get('tab') === '2'
    && localStorage.getItem('token')) {
  import('./components/inflow/newsletters/NewsletterPanel').catch(() => {});
}
const mountModule = isBookingSettingsPreview ? import('./components/inflow/booking/mountBookingSettingsPreview') : isPublicBooking ? import('./components/inflow/booking/mountPublicBooking') : import('./mountApplication');

mountModule.then(({ mountApplication, mountPublicBooking, mountBookingSettingsPreview }) => {
  (isBookingSettingsPreview ? mountBookingSettingsPreview : isPublicBooking ? mountPublicBooking : mountApplication)(document.getElementById('root'));
});
